import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo.png'
import _imports_1 from '../../assets/profile.jpg'


const _hoisted_1 = { ref: "audioPlayerRef" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "head-logo" }
const _hoisted_4 = {
  key: 0,
  class: "head-menu"
}
const _hoisted_5 = { class: "window-width" }
const _hoisted_6 = {
  key: 1,
  class: "dropdown-head-menu"
}
const _hoisted_7 = { class: "dropdown-head-menu-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "MP3 Player", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "dropdown-head-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("audio", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "img",
          alt: "Logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitRoute('home'))),
          src: _imports_0
        })
      ]),
      (_ctx.mp3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["server-work-indicator", _ctx.serverWork ? 'disabled' : 'enabled'])
            }, null, 2),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.window.width + 'x' + _ctx.window.height), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.mp3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("img", {
              class: "img",
              alt: "Logo",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu())),
              src: _imports_1
            }),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              (_ctx.mp3)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitRoute('mp3player2')))
                  }, "MP3 Player"))
                : _createCommentVNode("", true),
              (_ctx.mp3)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitRoute('mp3settings')))
                  }, "Настройки"))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exit()))
              }, "Выход")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "img",
              alt: "Logo",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitRoute('login'))),
              src: _imports_1
            })
          ]))
    ])
  ]))
}